import { Injectable, EventEmitter } from '@angular/core';
import { CurrentUser } from '../models/CurrentUser';
import { CookieService } from './cookie.service';
import { HelpDeskService } from './help-desk.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(
    private cookieService: CookieService,
    private helpDeskService: HelpDeskService
  ) {

    requestAnimationFrame(() => void helpDeskService.init())

    let authCookie = this.cookieService.getCookie("auth");
    let roleCookie = this.cookieService.getCookie("role");
    let userIdCookie = this.cookieService.getCookie("userId");
    let userNameCookie = this.cookieService.getCookie("userName");
    let isAdminConexiaCookie = this.cookieService.getCookie("isAdminConexia");

    if (this.currentUser == null)
      this.currentUser = new CurrentUser();

    if (authCookie != '') {
      this.currentUser.accessToken = JSON.parse(authCookie);
    }
    if (roleCookie != '') {
      this.currentUser.role = JSON.parse(roleCookie);
    }
    if (userIdCookie != '') {
      this.currentUser.userId = JSON.parse(userIdCookie);
    }
    if (userNameCookie != '') {
      this.currentUser.name = JSON.parse(userNameCookie);
    }
    if (isAdminConexiaCookie != '') {
      this.currentUser.isAdminConexia = JSON.parse(isAdminConexiaCookie);
    }
  }

  getQueryStrings(url) {
    var queries = {};
    var search;

    if (url == undefined) {
      search = window.location.search;
    } else {
      var indexOfInterrogation = url.indexOf("?");
      if (indexOfInterrogation == -1) {
        return queries;
      }
      search = url.substring(indexOfInterrogation);
    }
    if (search != undefined) {
      search = search.substring(1);
    }
    if (search == "") {
      return queries;
    }
    search = search.split("&");
    for (var i = 0; i < search.length; i++) {
      var keyValue = search[i].split("=");
      if (queries[keyValue[0].toLowerCase()] == undefined) {
        queries[keyValue[0].toLowerCase()] = keyValue[1];
      } else {
        if (queries[keyValue[0].toLowerCase()] instanceof Array) {
          queries[keyValue[0].toLowerCase()].push(keyValue[1]);
        } else {
          var currentVal = queries[keyValue[0].toLowerCase()];
          queries[keyValue[0].toLowerCase()] = [currentVal];
          queries[keyValue[0].toLowerCase()].push(keyValue[1]);
        }
      }
    }
    return queries;
  }

  public currentUser: CurrentUser;
}
